import { getFormData } from "../../../common";
import { createFrontYard } from "../../../repository/RealEstateRepository";

const FrontYardCreate = (props) => {

  const onSubmit = (e) => {
    e.preventDefault();
    const formData = getFormData(e.target);
    if (!formData.name) {
      window.Toast.danger("Name REQUIRED!");
      return;
    }
    createFrontYard(formData, () => {
      props.history.push("/realestate/frontyard");
    });
  };

  return (
    <>
      <form action="/" onSubmit={onSubmit}>
        <div className="row">
          <div className="col-0 col-sm-3"></div>
          <div className="col-12 col-sm-6 form-group text-left">
            <label>Name</label>
            <input name="name" className="form-control fluid" placeholder="Name" />
          </div>
        </div>

        <div className="row">
          <div className="col-0 col-sm-3"></div>
          <div className="col-12 col-sm-6 form-group text-left">
            <label>Population</label>
            <input name="population" className="form-control fluid" placeholder="Population" />
          </div>
        </div>

        <div className="row">
          <div className="col-0 col-sm-3"></div>
          <div className="col-12 col-sm-6 form-group text-left">
            <label>Job</label>
            <input name="companyCount" className="form-control fluid" placeholder="Number of companies" />
            <input name="majorCompanyCount" className="form-control fluid" placeholder="Number of major companies" />
          </div>
        </div>

        <div className="row">
          <div className="col-12 form-group">
            <button type="submit" className="btn btn-primary from-control">Create</button>
          </div>
        </div>
      </form>
    </>
  );
};

export { FrontYardCreate };
